import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
// Actions
import {
  reportsMainGenerateReportProgress,
  reportsMainGenerateReportUpdate
} from 'Redux/actions';

import {
  getTimeZone,
  handleAsyncReport,
  baseReportConditions,
  generateReportInstance,
  isJsonFormat, getCategoryFilter
} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getInputReport(report, page, rowsPerPage, sortField, sortOrder, requestFlag) {
  const { timeZone, sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath } = report;
  const {
    filterType,
    filterArray,
    startRange,
    endRange,
    unitsSelected,
    filterEntity,
    otherFilters,
    accumulateData = true,
    dates
  } = report.filters

  const baseConditionsQuery = baseReportConditions({
    report,
    name,
    dataResultPath,
    timeZone,
    delayed,
    unitsSelected,
    timeframeName,
    filterType,
    filterArray,
    categoryName,
    startRange,
    endRange,
    dates
  })
  try {
    let payload = {
      conditions: {
        ...baseConditionsQuery,
        sortField: {
          field: sortField || "deviceId",
          order: sortOrder === 'desc' ? 'DESC' : 'ASC'
        }
      },
      limit: rowsPerPage,
      offset: page
    };

    const csvFirstRow = []
    if(getCategoryFilter(filterType) !== "deviceId") {
      csvFirstRow.push( {
        "column": "driverName",
        header:  "Driver"
      })
    }
    if (report.export) {
      payload = {
        ...payload,
        limit: isJsonFormat(report?.exportType, dataResultPath) ? rowsPerPage : 5000,
        offset: isJsonFormat(report?.exportType, dataResultPath) ? page : 1,
        conditions: {
          ...payload.conditions,
          exportOptions: {
            sendByEmail,
            emailsTo,
            format: {
              fileFormat: report?.exportType || "json",
              formatOptions: "{\"addPagination\": \"true\", \"addLogo\": \"true\", \"addLine\": \"true\"}",
              durationFormat: report?.durationFormat
            },
            culture: report.lang,
            timeZone: getTimeZone(timeZone),
            folderName: "px-customer-reports",
            filePrefixName: "inputReport",
            columns: report?.exportType === "pdf" ?
              //pdf columns are defined in API because they are dependent on data
              [] :
              [
                ...csvFirstRow,
                {
                  "column": "deviceLabel",
                  "header":  "Unit"
                },
                {
                  "column": "event",
                  "header": "Event"
                },
                {
                  "column": "location",
                  "header": "Location"
                },
                {
                  "column": "dateTime",
                  "header": "DateTime"
                },
                {
                  "column": "total",
                  "header": "Total (minutes)"
                }
              ]
          }
        }
      }
    }
    let data = yield call(
      clientQuery,
      `query getInputReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getInputReport (conditions: $conditions, limit: $limit, offset: $offset) {
          ${generateReportInstance(report.export, dataResultPath, report.exportFromTable) ?
        `reportInstanceId`
        : `
            items {
                recordInfo {
                    entityId
                    entityLabel
                    tagId
                    tagLabel
                    startDate
                    endDate
                    recordType
                    groupLabel
                    groupIndex
                    groupTotal
                    groupTagColor
                }
                recordDetail {
                    deviceId
                    driverId
                    driverName
                    deviceLabel
                    event
                    onDatetime
                    onAddress
                    onLandmarkName
                    onLatitude
                    onLongitude
                    offDatetime
                    offAddress
                    offLandmarkName
                    offLatitude
                    offLongitude
                    duration
                     count
                     onInput
                    offInput
                    noData
                }
            }
            total
            limit
            offset
            category
        `}
        }
      }`,
      payload,
      endpoints.GRAPHQL_PX_REPORTING,
    );
    yield handleAsyncReport(report, data, accumulateData);
  } catch (exc) {
    ExceptionManager(exc, 'reports/inputReport', 'getInputReport');
    report.loading = false
    yield put(reportsMainGenerateReportProgress(report))
    if (!requestFlag) {
      let flag = true
      yield put(reportsMainGenerateReportUpdate(report, page, rowsPerPage, sortField, sortOrder, flag))
    } else {
      report.loading = false
      yield put(reportsMainGenerateReportProgress(report))
    }
  }
}


export default getInputReport;
